<template>
	<div>
		<p class="view_head">单位信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<labelInput :outInput="newform.company_name" :spanRequired="true" normalPlace="请输入单位名称"
				@inputChange="labelInput($event,'company_name')" spanTitle="单位名称" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.tax_number" :spanRequired="true" normalPlace="请输入统一社会信用代码"
				@inputChange="labelInput($event,'tax_number')" spanTitle="统一社会信用代码" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.legalperson" :spanRequired="true" normalPlace="请输入法定代表人"
				@inputChange="labelInput($event,'legalperson')" spanTitle="法定代表人" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>

			<div class="qc_list" style="width: 520px;">
				<p>企业资质和等级:</p>
				<div class="qc_list__Right" style="width: 350px;">
					<el-input v-model="newform.qualification" @blur="labelInput(newform.qualification,'qualification')"
						placeholder="请填写总承包资质最高等级"></el-input>
					<el-input v-model="newform.corporate_level"
						@blur="labelInput(newform.corporate_level,'corporate_level')" placeholder="请填写专业承包资质最高等级"
						style="margin-top: 10px;">
					</el-input>
				</div>
			</div>
			<labelInput :outInput="newform.contact_name" :spanRequired="true" normalPlace="请输入联系人"
				@inputChange="labelInput($event,'contact_name')" spanTitle="联系人" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.phone" :spanRequired="true" normalPlace="请输入联系电话"
				@inputChange="labelInput($event,'phone')" spanTitle="联系电话" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<div style="display: flex;align-items: center;height: 40px;width: 93%;">
				<label-select :outInput="[newform.province,newform.city]" componentWidth="550px" :spanRequired="true"
					@placeInfo="place1Info($event,'[province,city,area]')" @placeLevel="tongLevel = $event"
					:spanWidth="spanWidth" spanTitle="通讯地址">
				</label-select>
				<el-input v-model="newform.address" @blur="labelInput(newform.address,'address')"
					style="width: 520px;margin-left: 40px;" placeholder="请输入详细地址">
				</el-input>
			</div>
		</div>
		<p class="view_head">小组信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<labelInput :outInput="newform.group_name" :spanRequired="true" normalPlace="请输入小组名称"
				@inputChange="labelInput($event,'group_name')" spanTitle="小组名称" :spanWidth="spanWidth"
				componentWidth="92%">
			</labelInput>
			<labelInput :outInput="newform.group_desp" specilType="textarea" :maxLimit="200" :outRow="2"
				:spanRequired="true" normalPlace="请输入小组简介" @inputChange="labelInput($event,'group_desp')"
				spanTitle="小组简介" :spanWidth="spanWidth" componentWidth="92%">
			</labelInput>
			<datePicker ref="datepicker" :spanRequired="true" spanTitle="小组注册时间" pelaceHolder='请选择'
				componentWidth="520px" :spanWidth="spanWidth" @selectDate="labelInput($event,'register_time')">
			</datePicker>

			<labelInput :outInput="newform.group_person" :spanRequired="true" normalPlace="请输入小组人数"
				@inputChange="labelInput($event,'group_person')" spanTitle="小组人数" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.instructor_name" :spanRequired="true" normalPlace="请输入小组活动指导者姓名"
				@inputChange="labelInput($event,'instructor_name')" spanTitle="小组活动指导者姓名" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<div style="width: 500px;">
			</div>
			<labelInput :outInput="newform.completion_certificate" :spanRequired="true" normalPlace="请输入推进者培训结业证书编号"
				@inputChange="labelInput($event,'completion_certificate')" spanTitle="推进者培训结业证书编号" spanWidth="180px"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.issue_unit" :spanRequired="true" normalPlace="请输入发证单位"
				@inputChange="labelInput($event,'issue_unit')" spanTitle="发证单位" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<div class="qc_clumView" style="width: 85%;">
				<div class="qc_newAdd" style="width: 100%;">
					<p>小组主要成员:</p>
					<el-button @click="addNewTable">新增</el-button>
				</div>
				<div class="qc_clumView_right" style="width: 100%;">
					<emelentTable ref="elementTbteam" :outTable="outTable2" :outTabList="outTabList2"
						@editMore="getTable">
					</emelentTable>
					<addQcTable ref="addQcTable" @cancel="cancelSql" @finshTable="getTableData($event,'main_member')">
					</addQcTable>
				</div>
			</div>
		</div>
		<p class="view_head">成果信息</p>
		<div style="display: flex;flex-flow: column;">
			<labelInput :outInput="newform.achievement_name" :spanRequired="true" normalPlace="请输入成果名称"
				@inputChange="labelInput($event,'achievement_name')" spanTitle="成果名称" :spanWidth="spanWidth"
				componentWidth="92%">
			</labelInput>
			<div class="qc_list">
				<p>成果类型:</p>
				<div class="qc_list__Right">
					<el-radio-group v-model="newform.achievement_type"
						@change="labelInput(newform.achievement_type,'achievement_type')">
						<el-radio :label="1">创新型</el-radio>
						<el-radio :label="2">问题型</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="qc_clumView">
				<p>主要活动过程和效果:</p>
				<div class="qc_clumView_right">
					<el-input type="textarea" :rows="2" placeholder="请输入内容"
						@blur="labelInput(newform.activity,'activity')" v-model="newform.activity">
					</el-input>
				</div>
			</div>
			<div class="qc_clumView">
				<p>本成果社会和经济效益，是否形成企业标准和工法等情况:</p>
				<div class="qc_clumView_right">
					<el-input type="textarea" :rows="2" placeholder="请输入内容"
						@blur="labelInput(newform.economic_results,'economic_results')"
						v-model="newform.economic_results">
					</el-input>
				</div>
			</div>
			<div class="qc_clumView">
				<p>历年主要成果奖情况:</p>
				<div class="qc_clumView_right">
					<el-input type="textarea" :rows="2" placeholder="请输入内容"
						@blur="labelInput(newform.achievement_prize,'achievement_prize')"
						v-model="newform.achievement_prize">
					</el-input>
				</div>
			</div>
			<div class="qc_list">
				<p>是否发布:</p>
				<div class="qc_list__Right">
					<el-radio-group v-model="newform.is_publish" @change="labelInput(newform.is_publish,'is_publish')">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="2">否</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="qc_list">
				<p>推荐单位:</p>
				<div class="qc_list__Right">
					<el-select v-model="newform.recommend_unit" style="width: 350px;"
						@change="labelInput(newform.recommend_unit,'recommend_unit')" placeholder="请选择">
						<el-option v-for="item in options" :key="item.company_code" :label="item.name"
							:value="item.company_code">
						</el-option>
					</el-select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import labelInput from '../../../components/table/labelInput.vue'
	import emelentTable from '../../../components/table/elementTable.vue'
	import datePicker from '../../../components/table/datePicker.vue'
	import labelSelect from '../../../components/table/labelSelect.vue'
	import addQcTable from "../components/addQc_table.vue"
	import {
		getRecomCompany
	} from '../../../api/moudles/user.js'
	export default {
		data() {
			return {
				chooseIndex: 0,
				localForm: [],
				input: '',
				textarea: '',
				newform: {},
				spanWidth: '150px',
				// 推荐单位
				options: [],
				// 推荐单位
				recommendValue: '',
				// 是否发布
				radio: '1',
				outTable2: [],
				outTabList2: [{
						prop: 'name',
						label: '姓名',
						width: ''
					}, {
						prop: 'idcard',
						label: '身份证号码',
						width: '160px'
					}, {
						prop: 'f_school',
						label: '毕业院校',
						width: ''
					}, {
						prop: 'f_education',
						label: '学历',
						width: ''
					},
					{
						prop: 'f_major',
						label: '专业',
						width: ''
					},
					{
						prop: 'work_time',
						label: '工作时间',
						width: ''
					}, {
						prop: 'position',
						label: '目前岗位',
						width: ''
					},
					{
						prop: 'post',
						label: '职务',
						width: ''
					}, {
						prop: 'title',
						label: '职称',
						width: ''
					},
					// {
					// 	prop: 'reg_qualification',
					// 	label: '注册资格',
					// 	width: ''
					// },
				]
			}
		},
		components: {
			labelInput,
			emelentTable,
			datePicker,
			labelSelect,
			addQcTable
		},
		mounted() {
			this.getRecomCompany()
		},
		props: {
			datas: {
				type: Object,
				default: () => {}
			}
		},
		watch: {
			datas(newValue) {
				if (newValue) {
					newValue.is_publish = parseInt(newValue.is_publish)
					newValue.achievement_type = parseInt(newValue.achievement_type)
					this.$refs.datepicker.setTime(newValue.register_time)
					setTimeout(() => {
						this.newform = {
							...newValue
						}
					})
					if (newValue.main_member) {
						// this.$refs.elementTbteam.setTableData(newValue.main_member)
						newValue.main_member.forEach((item, index) => {
							this.chooseIndex++
							this.localForm[index] = item
							this.$set(this.outTable2, index, item)
						})
					}
				}
			}
		},
		methods: {
			// 取消表格操作
			cancelSql() {
				if (this.editType == '新增') {
					this.chooseIndex--
				}
			},
			// 新增表格
			addNewTable() {
				this.editType = '新增'
				this.$refs.addQcTable.openDialog(this.chooseIndex++)
			},
			// 获取表格动作
			getTable(e) {
				const [index, type] = e
				if (type == '编辑') {
					this.editType = '编辑'
					this.$refs.addQcTable.openDialog(index, this.localForm[index])
				} else if (type == '删除') {
					this.localForm.splice(index, 1)
					this.chooseIndex--
				}
			},
			// 获取table数据
			getTableData(e, vname) {
				const [evalue, index] = e
				this.localForm[index] = evalue
				this.$emit('reciveData', [vname, this.localForm])
				const {
					name,
					idcard,
					f_school,
					f_education,
					f_major,
					work_time,
					position,
					post,
					title,
					// reg_qualification
				} = evalue
				const newObj = {
					name,
					idcard,
					f_school,
					f_education,
					f_major,
					work_time,
					position,
					post,
					title,
					// reg_qualification
				}
				this.$set(this.outTable2, index, newObj)
			},
			async getRecomCompany() {
				let params = {
					project_code: '1'
				}
				await getRecomCompany({
					data: params,
					success: res => {
						this.options = res.data
					}
				})
			},
			labelInput(e, name) {
				// console.log(e, name)
				this.newform[name] = e
				this.$emit('reciveData', [name, e])
			},
			place1Info(e, name) {
				if (e.length > 1) {
					// [province,city,area]
					this.newform['province'] = e[0]
					this.newform['city'] = e[1]
					this.$emit('reciveData', ['province', e[0]])
					this.$emit('reciveData', ['city', e[1]])
				}
			},
			// 弹窗
			addInfo() {

			}
		}
	}
</script>

<style scoped>
	.view_head {
		font-size: 18px;
		font-weight: bold;
		margin-top: 20px;
	}

	.qc_list {
		display: flex;
		align-items: center;
		margin: 10px;
	}
	.qc_newAdd {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 92%;
		margin-bottom: 10px;
	}


	.qc_clumView {
		display: flex;
		flex-flow: column;
		margin: 10px;
		padding-left: 80px;
		/* padding-left: 170px; */
	}

	.qc_clumView p {
		text-align: left;
		font-size: 14px;
		display: inline-block;
		margin-bottom: 10px;
	}

	.qc_clumView_right {
		width: 92%;
	}

	.qc_list__Right {
		padding-left: 20px;
	}

	.qc_list p {
		font-size: 14px;
		width: 150px;
		text-align: right;
		display: inline-block;
	}
</style>
